import { Component, Input, AfterViewInit, SimpleChanges } from '@angular/core';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

@Component({
  selector: 'app-so-chart-doughnut',
  templateUrl: './so-chart-doughnut.component.html',
  styleUrls: ['./so-chart-doughnut.component.scss'],
})
export class SoChartDoughnutComponent implements AfterViewInit {
  newArray: number[] = [];
  @Input() size: string = '190';
  @Input() id!: string;
  @Input() title!: string;
  @Input() subTitle: string = '';
  @Input() footer: string = '';
  @Input() footerNumber: string = '';
  @Input() data: { label: string; numb: number }[] = [];
  chart: Chart | null = null;
  suma = 0;

  @Input() legentType: '' | 'footerTwoColumns' | 'right' | 'leftTwoColumns' =
    '';
  @Input() bgColorType = '';

  private colorByLabel: Record<string, string> = {};
  private fallbackColor = 'rgb(229, 229, 229)';

  private norm(s: string) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s+/g, '_');
  }

  private alias: Record<string, string> = {
    // canónicos
    entregado: 'entregado',
    leido: 'leido',
    recibido: 'recibido',
    enviada: 'enviada',
    no_entregado: 'no_entregado',
    no_etregado: 'no_entregado',
    no__entregado: 'no_entregado',
    noentregado: 'no_entregado',
    enviado: 'enviada',
    enviados: 'enviada',
  };

  private canon(key: string) {
    return this.alias[key] ?? key;
  }
  private ordenarData() {
    const orden = ['entregado', 'leido', 'recibido', 'enviada', 'no_entregado'];
    this.data.sort((a, b) => {
      const A = this.canon(this.norm(a.label));
      const B = this.canon(this.norm(b.label));
      const ia = orden.indexOf(A);
      const ib = orden.indexOf(B);
      return (
        (ia === -1 ? Number.MAX_SAFE_INTEGER : ia) -
        (ib === -1 ? Number.MAX_SAFE_INTEGER : ib)
      );
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bgColorType']) {
      this.getBackgroundColor();
    }

    if (changes['data']) {
      this.getBackgroundColor();
      this.data = changes['data'].currentValue ?? [];
      this.ordenarData();
      this.newArray = this.data.map((d) => d.numb);
      this.suma = this.newArray.reduce((t, n) => t + n, 0);

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      this.chartDoughnut();
    }
  }

  ngAfterViewInit() {
    this.getBackgroundColor();
    this.ordenarData();
    this.newArray = this.data.map((d) => d.numb);
    this.suma = this.newArray.reduce((t, n) => t + n, 0);
    this.chartDoughnut();
  }

  private chartDoughnut() {
    const values = this.data.map((d) => d.numb);
    const total = values.reduce((a, b) => a + b, 0);

    const bg = this.data.map((d) => {
      const key = this.canon(this.norm(d.label));
      return this.colorByLabel[key] ?? this.fallbackColor;
    });

    this.chart = new Chart('doughnut-' + this.id, {
      type: 'doughnut',
      data: {
        datasets: [{ data: values, backgroundColor: bg }],
      },
      options: {
        cutout: '70%',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const v = Number(ctx.raw);
                const pct = total ? ((v / total) * 100).toFixed(2) : '0.00';
                const label = this.data[ctx.dataIndex]?.label ?? '';
                return `${label} ${v} (${pct}%)`;
              },
            },
          },
        },
      },
    });
  }

  numberToWords(num: number): string {
    const words: string[] = [
      'cero',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
    ];
    return num >= 0 && num <= 20 ? words[num] : 'Número no soportado';
  }

  numberToWordsRight(num: number): string {
    return 'color-' + num;
  }

  getBackgroundColor() {
    if (this.bgColorType === 'Message') {
      this.colorByLabel = {
        whatsapp: 'rgb(37, 211, 102)',
        facebook: 'rgb(59, 89, 152)',
        sms: 'rgb(42, 166, 154)',
        call: 'rgb(239, 0, 183)',
        email: 'rgb(243, 140, 46)',
        otros: this.fallbackColor,
      };
    } else {
      this.colorByLabel = {
        entregado: 'rgb(0, 42, 127)',
        leido: 'rgb(72, 82, 175)',
        recibido: 'rgb(113, 141, 0)',
        enviada: 'rgb(163, 189, 54)',
        no_entregado: 'rgb(215, 240, 104)',
        otros: this.fallbackColor,
      };
    }
  }

  getMat(datos: any) {
    return Math.ceil(datos / 2);
  }

  calculatePercentage(value: number | null | undefined): string {
    if (value == null) return '0.00';
    if (!this.suma) return '0.00';
    const num = Number(value);
    if (isNaN(num)) return '0.00';
    return ((num / this.suma) * 100).toFixed(2);
  }
}
